import { Extension } from '@tiptap/core';

const TabExtension = Extension.create({
  name: 'tab',

  addOptions() {
    return {
      tabSize: 4, // Размер табуляции в пробелах
    };
  },

  addKeyboardShortcuts() {
    return {
      Tab: () => {
        // Вставляем символ табуляции или пробелы в зависимости от настроек
        const spaces = '\u00A0'.repeat(this.options.tabSize); // неразрывные пробелы
        this.editor.commands.insertContent(spaces);
        return true;
      },
      'Shift-Tab': () => {
        // Обратная табуляция - удаляем табуляцию или пробелы перед курсором
        const { state } = this.editor;
        const { from } = state.selection;
        const spaces = this.options.tabSize;
        
        // Проверяем наличие пробелов или табуляции перед курсором
        if (from >= spaces) {
          const text = state.doc.textBetween(from - spaces, from);
          const hasSpaces = text.match(/^[\s\u00A0]+$/);
          
          if (hasSpaces) {
            this.editor.commands.deleteRange({ from: from - spaces, to: from });
          }
        }
        return true;
      }
    };
  },
});

export default TabExtension;